import { USER_QUERY_KEYS } from './keys';
import { userAPIClient } from '../userAPIClient';
import type { QueryClient } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';
import { mutationOptions } from '../../common/utils';
import type { UpdateUserRequest, UpdateUserResponse, GetUserResponse } from './types';

export const USER_QUERIES = {
  getCookieUser: () =>
    queryOptions({
      queryKey: USER_QUERY_KEYS.getCookieUser(),
      queryFn: () => userAPIClient.getCookieUser(),
    }),
  getUser: () =>
    queryOptions<GetUserResponse>({
      queryKey: USER_QUERY_KEYS.getUser(),
      queryFn: () => userAPIClient.getUser(),
    }),
  getCookieUserMutation: (queryClient: QueryClient) =>
    mutationOptions({
      mutationKey: USER_QUERY_KEYS.getCookieUser(),
      mutationFn: () => userAPIClient.getCookieUser(),
      onSuccess: (data) => {
        queryClient.setQueryData(USER_QUERY_KEYS.getCookieUser(), data);
      },
    }),
  updateUser: (queryClient: QueryClient) =>
    mutationOptions<UpdateUserResponse, unknown, UpdateUserRequest>({
      mutationKey: USER_QUERY_KEYS.updateUser(),
      mutationFn: (payload) => userAPIClient.updateUser(payload),
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: USER_QUERY_KEYS.getCookieUser() });
      },
    }),
};
